/* GET NAILS / Despre noi 01 - control Play/Pauza pentru desktop si mobil. */
(() => {
  if (window.gnAboutIntroVideoRegistered) return;
  window.gnAboutIntroVideoRegistered = true;

  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function initialize(root) {
    const sections = root.matches && root.matches('.gn-about-intro-video')
      ? [root]
      : root.querySelectorAll('.gn-about-intro-video');

    sections.forEach((section) => {
      if (section.dataset.gnIntroVideoReady === 'true') return;

      const frame = section.querySelector('.gn-about-intro-video__frame');
      const videos = frame ? Array.from(frame.querySelectorAll('video')) : [];
      const button = frame && frame.querySelector('[data-gn-about-video-toggle]');
      if (!frame || videos.length === 0 || !button) return;
      section.dataset.gnIntroVideoReady = 'true';

      function visibleVideo() {
        if (videos.length === 1) return videos[0];
        const mobile = frame.querySelector('.gn-about-intro-video__video--mobile');
        const desktop = frame.querySelector('.gn-about-intro-video__video--desktop');
        return mobileQuery.matches && mobile ? mobile : (desktop || mobile || videos[0]);
      }

      function sync() {
        const active = visibleVideo();
        const playing = !!active && !active.paused && !active.ended;
        frame.dataset.playing = String(playing);
        button.setAttribute('aria-label', playing ? 'Pune videoclipul pe pauza' : 'Reda videoclipul');
        button.setAttribute('aria-pressed', String(playing));
      }

      function toggle() {
        const active = visibleVideo();
        if (!active) return;
        if (active.paused || active.ended) {
          const request = active.play();
          if (request && typeof request.then === 'function') request.then(sync).catch(sync);
        } else {
          active.pause();
          sync();
        }
      }

      function onBreakpointChange() {
        const active = visibleVideo();
        videos.forEach((video) => {
          if (video !== active && !video.paused) video.pause();
        });
        sync();
      }

      videos.forEach((video) => {
        ['play', 'pause', 'ended', 'error'].forEach((event) => video.addEventListener(event, sync));
      });
      button.addEventListener('click', toggle);
      if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', onBreakpointChange);
      else if (mobileQuery.addListener) mobileQuery.addListener(onBreakpointChange);
      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
